  document.addEventListener('DOMContentLoaded', function() {
    function initSliders(root) {
      root.querySelectorAll('[data-pc-slider]:not([data-pc-slider-init])').forEach(function(slider) {
        slider.setAttribute('data-pc-slider-init', '');
        var track = slider.querySelector('.pc-slider__track');
        var slides = slider.querySelectorAll('.pc-slider__slide');
        var dots = slider.querySelectorAll('.pc-slider__dot');
        var current = 0;

        function goTo(index) {
          slides[current].classList.remove('is-active');
          if (dots[current]) dots[current].classList.remove('is-active');
          current = (index + slides.length) % slides.length;
          track.style.transform = 'translateX(-' + (current * 100) + '%)';
          slides[current].classList.add('is-active');
          if (dots[current]) dots[current].classList.add('is-active');
        }

        var btnPrev = slider.querySelector('.pc-slider__btn--prev');
        var btnNext = slider.querySelector('.pc-slider__btn--next');
        if (btnPrev) btnPrev.addEventListener('click', function(e) { e.preventDefault(); goTo(current - 1); });
        if (btnNext) btnNext.addEventListener('click', function(e) { e.preventDefault(); goTo(current + 1); });
        dots.forEach(function(dot, i) { dot.addEventListener('click', function() { goTo(i); }); });

        // Swipe mobile
        var startX = 0;
        track.addEventListener('touchstart', function(e) { startX = e.touches[0].clientX; }, { passive: true });
        track.addEventListener('touchend', function(e) {
          var diff = startX - e.changedTouches[0].clientX;
          if (Math.abs(diff) > 40) goTo(diff > 0 ? current + 1 : current - 1);
        });
      });
    }

    initSliders(document);

    // Réinitialisation si chargement dynamique (ex: pagination infinie)
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        m.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) initSliders(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });